// Registers the app service worker.
//
// `push-sw.js` does triple duty:
//   1. push tap-to-wake,
//   2. INSTANT IMAGES — cache-first caching of remote media/avatars by stable
//      path, so an image paints from disk on reload instead of re-fetching the
//      presigned S3 URL (the per-session signature defeats the browser's own
//      HTTP cache). This is how WhatsApp/Telegram Web get instant-on-reload
//      media. Active in ALL environments.
//   3. OFFLINE app-shell — precache of the SPA shell + hashed build assets so
//      the app opens with no network. Production-ONLY (the SW self-detects dev
//      and skips it), because stale-while-revalidate on same-origin code would
//      fight Vite's HMR.
//
// Runs for EVERY user at boot — independent of push, which only registers the
// same worker when notifications are enabled. Registering the same URL + scope
// twice is idempotent, so the two paths coexist.

import { log } from '@core/log/log';

const SW_URL = '/push-sw.js';
const SW_SCOPE = '/';

export function registerAppServiceWorker(): void {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;

  // Register after load so the SW install/precache never competes with the
  // first paint's critical requests.
  const run = (): void => {
    navigator.serviceWorker.register(SW_URL, { scope: SW_SCOPE }).then(
      () => log.info({ event: 'sw.register.ok' }),
      (err: unknown) => log.warn({ event: 'sw.register.failed', error: (err as Error).message }),
    );
  };

  if (typeof window !== 'undefined' && document.readyState === 'complete') {
    run();
  } else if (typeof window !== 'undefined') {
    window.addEventListener('load', run, { once: true });
  }
}
